module.exports = __webpack_public_path__ + "41548a4d368158e2366de41ac8758b11.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/floor_items/football.png
// module id = 3399
// module chunks = 0